import script from "./CompanyOperatorLicensesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyOperatorLicensesPanel.vue?vue&type=script&setup=true&lang=js"

import "./CompanyOperatorLicensesPanel.vue?vue&type=style&index=0&id=0f54a118&lang=scss"

const __exports__ = script;

export default __exports__